import { render } from "./userListInfoDialog.vue?vue&type=template&id=23884450&scoped=true"
import script from "./userListInfoDialog.vue?vue&type=script&lang=js"
export * from "./userListInfoDialog.vue?vue&type=script&lang=js"

import "./userListInfoDialog.vue?vue&type=style&index=0&id=23884450&scoped=true&lang=css"

import exportComponent from "D:\\yiban\\WebProject\\yiban-admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23884450"]])

export default __exports__